import { render, staticRenderFns } from "./AddNewClientPopUp.vue?vue&type=template&id=f4ee8438"
import script from "./AddNewClientPopUp.vue?vue&type=script&lang=js"
export * from "./AddNewClientPopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports